import { styled } from 'theme'

export const StyledMessageList = styled.ul`
  background-color: white;
`
